<div class="container">
  <h1>Change Password</h1>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <hr />
    <div class="row">
      <div class="col-6">
        <p>Password Requirements:</p>
        <ul>
          <li>Must be at least 8 characters</li>
          <li>Must not exceed 14 characters</li>
          <li>Must not contain any spaces</li>
          <li>Must include at least 1 of each of the following:</li>
          <ul>
            <li>lowercase letter</li>
            <li>uppercase letter</li>
            <li>number</li>
            <li>special character (examples: !&#64;#$%&)</li>
          </ul>
        </ul>
      </div>
      <div class="col-6">

      </div>
    </div>

    <hr />
    <div class="row">
      <div class="mb-3 col">
        <label>Password</label>
        <input type="password" formControlName="password" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
          @if (submitted && f.password.errors) {
            <div class="invalid-feedback">
              @if (f.password.errors.required) {
                <div>Password is required</div>
              }
              @if (f.password.errors.minlength) {
                <div>Password must be at least 8 characters</div>
              }
              @if (f.password.errors.maxlength) {
                <div>Password must 14 characters or fewer</div>
              }
              @if (f.password.errors.hasUpperCase) {
                <div>Password must contain at least 1 uppercase letter</div>
              }
              @if (f.password.errors.hasLowerCase) {
                <div>Password must contain at least 1 lowercase letter</div>
              }
              @if (f.password.errors.hasNumber) {
                <div>Password must contain at least 1 number</div>
              }
              @if (f.password.errors.hasSpecialCharacters) {
                <div>Password must contain at least 1 special
                character</div>
              }
              @if (f.password.errors.hasSpaces) {
                <div>Password must not contain any spaces</div>
              }
            </div>
          }
        </div>
        <div class="mb-3 col">
          <label>Confirm Password</label>
          <input type="password" formControlName="confirmPassword" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
            @if (submitted && f.confirmPassword.errors) {
              <div class="invalid-feedback">
                @if (f.confirmPassword.errors.required) {
                  <div>Confirm Password is required</div>
                }
                @if (f.confirmPassword.errors.mustMatch) {
                  <div>Passwords must match</div>
                }
              </div>
            }
          </div>
        </div>
        <div class="mb-3">
          <button type="submit" [disabled]="loading" class="btn btn-primary mr-2">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            Update
          </button>
          <a routerLink="../" href="" class="btn btn-link">Cancel</a>
        </div>
      </form>
    </div>